var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.405 14.176v2.5a1.667 1.667 0 0 1-1.816 1.667 16.49 16.49 0 0 1-7.192-2.559 16.25 16.25 0 0 1-5-5A16.492 16.492 0 0 1 1.84 3.56a1.667 1.667 0 0 1 1.658-1.816h2.5a1.667 1.667 0 0 1 1.667 1.433c.105.8.301 1.586.583 2.342a1.667 1.667 0 0 1-.375 1.758L6.814 8.334a13.333 13.333 0 0 0 5 5l1.058-1.058a1.667 1.667 0 0 1 1.758-.375 10.7 10.7 0 0 0 2.342.583 1.667 1.667 0 0 1 1.433 1.692Z",
    stroke: "#30384C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.072 .076)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPhone;